(function (root, factory) {
  const api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.DominatorDealerStateSelector = api;
}(typeof globalThis === 'object' ? globalThis : this, function (root) {
  'use strict';

  function bindStateSelectors(documentObject, navigate) {
    const document = documentObject || root.document;
    if (!document || typeof document.querySelectorAll !== 'function') return 0;
    const go = typeof navigate === 'function'
      ? navigate
      : function (url) { root.location.assign(url); };
    let bound = 0;
    document.querySelectorAll('[data-state-link-select]').forEach(function (select) {
      if (select.dataset.dealerStateSelectorBound === 'true') return;
      select.dataset.dealerStateSelectorBound = 'true';
      select.addEventListener('change', function () {
        const url = String(select.value || '').trim();
        if (url) go(url);
      });
      bound += 1;
    });
    return bound;
  }

  return { bindStateSelectors: bindStateSelectors };
}));

